import styled from "styled-components";

const LinkCenter = styled.a`
	display: flex;
	align-items: center;
`;

export { LinkCenter };
